function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "event_busy_24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon/notification/event_busy_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.875 10.5H47.25V5.25H42V10.5H21V5.25H15.75V10.5H13.125C10.2375 10.5 7.875 12.8625 7.875 15.75V52.5C7.875 55.3875 10.2375 57.75 13.125 57.75H49.875C52.7625 57.75 55.125 55.3875 55.125 52.5V15.75C55.125 12.8625 52.7625 10.5 49.875 10.5ZM49.875 52.5H13.125V26.25H49.875V52.5ZM13.125 15.75V21H49.875V15.75H13.125Z",
  fill: "#749DFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M21.6038 45.7014L24.3863 48.4839L30.7913 42.0789L37.1963 48.4839L39.9788 45.7014L33.5738 39.2964L39.9788 32.8914L37.1963 30.1089L30.7913 36.5139L24.3863 30.1089L21.6038 32.8914L28.0088 39.2964L21.6038 45.7014Z",
  fill: "#A7EAFF"
}));

var SvgSurveyNotYetLiveIcon = function SvgSurveyNotYetLiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurveyNotYetLiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/survey-not-yet-live-icon.a6b518fb.svg";
export { ForwardRef as ReactComponent };